import React from 'react';

import { DashboardAvatarProps } from '../DashboardAvatar/DashboardAvatar.decl';

import { DashboardAvatar } from '@components/DashboardAvatar/DashboardAvatar';

export const UserAvatar = React.memo(
  ({ initials, id, src, ...avatarProps }: DashboardAvatarProps) => {
    const dataTest = id ? `user-avatar-${id}` : 'user-avatar';

    return (
      <DashboardAvatar
        src={src}
        initials={initials}
        variant='grey'
        data-test={dataTest}
        {...avatarProps}
      />
    );
  }
);
